/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './Button.scss'
import React from 'react'

/**
 * type: [primary, secondary, dark, light, danger]
 * size: [lg, md]
 */
function Button(props) {
  const type = props.type ? 'btn-' + props.type : ''
  const size = props.size ? 'btn-' + props.size : ''
  const className = props.className || ''

  return (
    <button className={`Button ${type} ${size} ${className}`} onClick={props.onClick} disabled={props.disabled}>
      {props.children}
    </button>
  )
}

export default Button
